<div class="bucket">
    <div class="bucket-title">
        <h2 class="bucket-title" [i18n]="'forced-checkin.search.title'"></h2>
        <i class="fas fa-chevron-left fa-x" (click)="showBucketChange.emit(false)"></i>
    </div>

    <div class="tabs">
        <div class="filter-tab tab" [ngClass]="[resultTab ? '' : 'active']" (click)="resultTab = false"
             [i18n]="'forced-checkin.search.tabs.filters-title'">
        </div>
        <div class="result-tab tab" [ngClass]="[resultTab ? 'active' : '']" (click)="selectResultTab()">
            <span class="result-tab-title" [i18n]="'forced-checkin.search.tabs.results-title'"></span>
            <span class="result-number" *ngIf="!noFirstSearch">{{ totalForcedCheckins }}</span>
        </div>
    </div>

    <div class="tab-filter-content" *ngIf="!resultTab">
        <div class="content">
            <div class="search-title title" [i18n]="'forced-checkin.search.search-title'"></div>
            <div *ngIf="!userIsCarrierManager" class="data-filter">
                <div class="select-data-filter">
                    <label for="region-select" [i18n]="'forced-checkin.search.region-select-label'"></label>
                    <ng-select id="region-select"
                               [items]="regions"
                               [(ngModel)]="selectedRegion"
                               (clear)="clearRegion()"
                               [disabled]="selectedCarrier?.id !== null"
                               [loading]="loadingRegions"
                               [addTag]="true"
                               [hideSelected]="false"
                               [multiple]="false"
                               [clearable]="true"
                               [bindLabel]="'name'"
                               [placeholder]="'-- Select a Region --'"
                               [notFoundText]="'Region not found'">
                    </ng-select>
                </div>
                <div class="separator" [i18n]="'forced-checkin.search.select-separator'"></div>
                <div class="select-data-filter">
                    <label for="carrier-select" [i18n]="'forced-checkin.search.carrier-select-label'"></label>
                    <ng-select id="carrier-select"
                               [items]="carriers"
                               [(ngModel)]="selectedCarrier"
                               (clear)="clearCarrier()"
                               [disabled]="selectedRegion?.id !== null"
                               [loading]="loadingCarriers"
                               [addTag]="true"
                               [hideSelected]="false"
                               [multiple]="false"
                               [clearable]="true"
                               [bindLabel]="'name'"
                               [placeholder]="'-- Select a Carrier --'"
                               [notFoundText]="'Carrier not found'">
                    </ng-select>
                </div>
                <div class="separator"></div>
            </div>
            <div class="radio-container data-filter">
                <div class="title" [i18n]="'forced-checkin.search.dates-ranges.title'"></div>
                <div class="radio-input">
                    <input type="radio" id="day" name="range"
                           (click)="setDateRange(dateRanges.ONE_DAY)"
                           [checked]="dateRange === dateRanges.ONE_DAY">
                    <label for="day" [i18n]="'forced-checkin.search.dates-ranges.day'"></label>
                </div>
                <div class="radio-input">
                    <input type="radio" id="week" name="range"
                           (click)="setDateRange(dateRanges.ONE_WEEK)"
                           [checked]="dateRange === dateRanges.ONE_WEEK">
                    <label for="week" [i18n]="'forced-checkin.search.dates-ranges.week'"></label>
                </div>
                <div class="radio-input">
                    <input type="radio" id="month" name="range"
                           (click)="setDateRange(dateRanges.ONE_MONTH)"
                           [checked]="dateRange === dateRanges.ONE_MONTH">
                    <label for="month" [i18n]="'forced-checkin.search.dates-ranges.month'"></label>
                </div>
            </div>
            <div class="data-filter">
                <div class="title" [i18n]="'forced-checkin.search.plant.title'"></div>
                <input class="form-control" type="text"
                       [(ngModel)]="plantSearchFilterValue"
                       [i18n]="[{target: 'attribute:placeholder', key: 'forced-checkin.search.plant.help'}]">
                <span class="clearable__clear" (click)="clearInput()">&times;</span>
            </div>
        </div>

        <div class="bottom-buttons">
            <button class="btn btn-sm erase" (click)="resetCriteria()">
                <i class="fas fa-ban fa-x"></i>
                <span [i18n]="'realtime-tracking.load-tracking-map.bucket.erase-criteria'"></span>
            </button>
            <button class="btn btn-sm search"
                    (click)="searchPlants()"
                    [disabled]="!selectedCarrier && !selectedRegion && !userIsCarrierManager">
                <i class="fas fa-search fa-x"></i>
                <span [i18n]="'forced-checkin.search.whole-region-search-button'"></span>
            </button>
        </div>
    </div>

    <div class="tab-result-content" *ngIf="resultTab">
        <div class="no-results" *ngIf="noResult">
            <div class="message" [i18n]="'forced-checkin.search.no-results'"></div>
            <button class="btn btn-sm return" (click)="resultTab = false">
                <i class="fas fa-long-arrow-alt-left fa-2x"></i>
                <span [i18n]="'forced-checkin.search.return'"></span>
            </button>
        </div>

        <div class="result" *ngIf="!noResult">
            <div class="title"
                 [i18n]="[{target: 'innerHTML', key: 'forced-checkin.search.results-title', params: {number: totalForcedCheckins}}]">
            </div>
            <div class="result-list">
                <div class="plant"
                     *ngFor="let res of forcedCheckinResult"
                     [class.selected]="selectedPlantGlid ? res.glid === selectedPlantGlid : false"
                     (click)="selectedPlantGlidChange.emit(res.glid)">
                    <div class="plant-id">
                        <i class="fa fa-map-marker-alt"></i><span class="name">{{res.name}}</span> <span class="glid">({{res.glid}})</span>
                    </div>
                    <div class="nb-checkin">{{res.nbForcedCheckin}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="detail-links" *ngIf="!userIsCarrierManager && selectedPlantGlid">
        <a class="link btn btn-primary" (click)="goToLocationConfig(selectedPlantGlid)">
            <i class="fas fa-cog"></i>
            <span [i18n]="'forced-checkin.links.config'"></span>
        </a>
        <a class="link btn btn-primary" (click)="goToForcedCheckinLogEvents(selectedPlantGlid)">
            <i class="fas fa-table"></i>
            <span [i18n]="'forced-checkin.links.logs'"></span>
        </a>
    </div>
</div>
